module.exports = __webpack_public_path__ + "static/media/Kupon.20817634.png";